import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';
import DescriptionRenderer, { DescriptionSegment } from './DescriptionRenderer';

interface DescriptionGroupProps {
    description: DescriptionSegment[];
}

const DescriptionGroup: React.FC<DescriptionGroupProps> = ({ description }) => {
    const { isDarkMode } = useDarkMode();

    return (
        <>
            {description && (
                <div>
                    <h1 className="col kanit-extrabold">Overview</h1>
                    <div
                        className={`card row release-info-container ${isDarkMode ? 'dark-mode-3' : 'light-mode-3'}`}
                    >
                        <DescriptionRenderer description={description} />
                    </div>
                </div>
            )}
        </>
    );
};

export default DescriptionGroup;


